import CommunitiesLayout from "./Layout"
import SettingsApp from "../../communities/pages/settings/App"

const Settings = (props) => {
  return <SettingsApp />
}
Settings.layout = (page) => <CommunitiesLayout>{page}</CommunitiesLayout>
export default Settings
